import Courses from "./components/Courses";
import CTA from "./components/CTA";
import DownloadApp from "./components/DownloadApp";
import Footer from "./components/Footer";
import Header from "./components/Header";
import HowIt from "./components/HowIt";
import Slider from "./components/Slider";
import Testimonials from "./components/Testimonials";

function App() {
  return (
    <>
        <Header />
        {/*  Overlay Start **/}
        <div className="overlay"></div>
        <Slider></Slider>
        <Courses></Courses>
        <CTA></CTA>
        <HowIt></HowIt>
        <DownloadApp></DownloadApp>
        <Testimonials></Testimonials>
        <Footer />
    </>
  );
}

export default App;
